import { Link, useLocation } from 'react-router-dom';

const menu = [
  { id: 'cms', label: 'Fotos del sitio (CMS)', link: '/admin/cms' },
  { divider: true },
  { id: 'gyms', label: 'Gimnasios' },
  { id: 'clubs', label: 'Clubs' },
  { id: 'productos', label: 'Tienda / Productos' },
  { divider: true },
  { id: 'usuarios', label: 'Usuarios' },
  { id: 'entrenadores', label: 'Entrenadores' },
  { id: 'afiliaciones', label: 'Afiliaciones' },
  { id: 'valores-afiliacion', label: 'Valores de afiliación' },
  { id: 'eventos', label: 'Eventos' },
  { id: 'participantes', label: 'Lista de participantes' },
  { id: 'records', label: 'Récords' },
  { id: 'marcas', label: 'Actualizar marcas personales' },
  { id: 'rankings', label: 'Rankings' },
];

const AdminSidebar = ({ activeView, setActiveView, open, onClose }) => {
  const location = useLocation();
  const isCMSActive = location.pathname === '/admin/cms';

  return (
    <>
      <aside
        className={`admin-sidebar ${open ? 'open' : ''}`}
        role="navigation"
        aria-label="Menú de administración"
      >
        <button
          type="button"
          onClick={() => setActiveView('dashboard')}
          className={`admin-sidebar-title ${activeView === 'dashboard' ? 'active' : ''}`}
          aria-current={activeView === 'dashboard' ? 'page' : undefined}
        >
          <span className="crown" aria-hidden="true">👑</span>
          <span>Administración</span>
        </button>

        <nav className="admin-sidebar-nav">
          {menu.map((item, index) =>
            item.divider ? (
              <hr key={index} className="admin-divider" />
            ) : item.link ? (
              <Link
                key={item.id}
                to={item.link}
                className={`admin-nav-item ${isCMSActive ? 'active' : ''}`}
                style={{ textDecoration: 'none' }}
                aria-current={isCMSActive ? 'page' : undefined}
                onClick={onClose}
              >
                {item.label}
              </Link>
            ) : (
              <button
                key={item.id}
                type="button"
                onClick={() => {
                  setActiveView(item.id);
                  onClose?.();
                }}
                className={`admin-nav-item ${activeView === item.id ? 'active' : ''}`}
                aria-current={activeView === item.id ? 'page' : undefined}
              >
                {item.label}
              </button>
            )
          )}
        </nav>
      </aside>

      <style>{`
        .admin-sidebar {
          width: 260px;
          background: #ffffff;
          border-right: 1px solid #f0f0f0;
          padding: 1.5rem 1.25rem;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        @media (max-width: 768px) {
          .admin-sidebar {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            z-index: 50;
            transform: translateX(-100%);
            box-shadow: none;
          }
          .admin-sidebar.open {
            transform: translateX(0);
            box-shadow: 4px 0 20px rgba(0,0,0,0.15);
          }
        }

        .admin-sidebar-title {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-weight: 700;
          color: #1a4d8c;
          font-size: 1rem;
          margin-bottom: 2rem;
          width: 100%;
          border: none;
          background: none;
          cursor: pointer;
          padding: 0.55rem 0.75rem;
          text-align: left;
          border-radius: 6px;
          transition: all 0.15s ease;
        }
        .admin-sidebar-title:hover {
          background: #f5f8fc;
        }
        .admin-sidebar-title.active {
          background: #e8f0fb;
          font-weight: 600;
        }
        .admin-sidebar-title.active::before {
          content: '';
          width: 4px;
          height: 100%;
          background: #1a4d8c;
          border-radius: 4px;
          margin-right: 8px;
        }

        .crown { font-size: 1.2rem; }

        .admin-sidebar-nav {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .admin-nav-item {
          display: flex;
          align-items: center;
          gap: 0.6rem;
          padding: 0.55rem 0.75rem;
          font-size: 0.9rem;
          color: #444;
          background: none;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          text-align: left;
          transition: all 0.15s ease;
          width: 100%;
          font-family: inherit;
        }

        .admin-nav-item:hover {
          background: #f5f8fc;
          color: #1a4d8c;
        }

        .admin-nav-item.active {
          background: #e8f0fb;
          color: #1a4d8c;
          font-weight: 600;
        }

        .admin-nav-item.active::before {
          content: '';
          width: 4px;
          height: 100%;
          background: #1a4d8c;
          border-radius: 4px;
          margin-right: 8px;
        }

        .admin-divider {
          border: none;
          border-top: 1px solid #eee;
          margin: 1rem 0;
        }
      `}</style>
    </>
  );
};

export default AdminSidebar;
